import React, { useContext } from 'react';
import { StyledShowThumbnailsSidebarButton } from './show-thumbnails-sidebar-button.styles';
import { Context } from '../../../store/store';

const ShowThumbnailsSidebarButton = () => {
  const [, dispatch] = useContext(Context);
  const handleClick = () => {
    dispatch({ type: 'TOGGLE_THUMBNAILS_SIDEBAR' });
  };

  return (
    <StyledShowThumbnailsSidebarButton onClick={handleClick}>
      Эскизы страниц
    </StyledShowThumbnailsSidebarButton>
  );
};

export default ShowThumbnailsSidebarButton;
